<template>
    <b-row>
        <!-- <dash
            icon="fa fa-file-text-o"
            titulo="REQUISIÇÕES"
            @click.native="toRequisicoes()"
        ></dash> -->
        <dash
            icon="fa fa-file-text-o"
            titulo="SERVIÇOS"
            @click.native="toComprometimentos()"
        ></dash>

        <dash
            icon="fa fa-file-text-o"
            titulo="BOLETINS DE MEDIÇÃO"
            @click.native="toBoletinsMedicao()"
        ></dash>
    </b-row>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    },

    methods: {
        toRequisicoes() {
            if (this.$route.name === 'FornecedoresContratos_Detalhar') {
                this.$router.push({ name: 'FornecedoresContratos_Requisicoes' })
            } else {
                this.$router.push({ name: 'FornecedorContratos_Requisicoes' })
            }
        },

        toComprometimentos() {
            if (this.$route.name === 'FornecedoresContratos_Detalhar') {
                this.$router.push({
                    name: 'FornecedoresContratos_Comprometimentos'
                })
            } else {
                this.$router.push({
                    name: 'FornecedorContratos_Comprometimentos'
                })
            }
        },

        toBoletinsMedicao() {
            this.$router.push({ name: 'FornecedorContratos_BoletinsMedicoes' })
        },
    }
}
</script>
